<template>
<body>
 <Front-Header> </Front-Header>
  <div>
    <stripe-checkout
      ref="checkoutRef"
      mode="payment"
    :pk="publishableKey"
      :line-items="lineItems"
      :success-url="successURL"
      :cancel-url="cancelURL"
      @loading="v => loading = v"
    />
	<button  @click="submit" style="
    background: #03e1bc;
    position: relative;
    z-index: 9999;
">Pay now!</button>

  </div>
<Front-Footer> </Front-Footer>
   </body>
</template>

<script>
import { StripeCheckout } from '@vue-stripe/vue-stripe';
import Header from "./Front-Header";
import Footer from "./Front-Footer";
export default {
  components: {
    StripeCheckout,
    "Front-Header": Header,
    "Front-Footer": Footer,
  },
  data () {
    this.publishableKey ="pk_test_51Jn0GYSCn9RmGB5DvmMHOu36CbYJFRpRbPpCGRmqUjLsK7DTBiOHdwQw7n1nzUBo4ds9sV1D1TTkmgfIWIjaoCsX0006wPGnYU";
    return {
      loading: false,
      lineItems: [
        {
          price: "return", // The id of the one-time price you created in your Stripe dashboard
          quantity: 1,
        },
      ],
      successURL: 'https://intro.ae/cart',
      cancelURL: 'https://intro.ae/cart',
    };
  },
  methods: {
    submit () {
	alert("hi");
      // You will be redirected to Stripe's secure checkout page
      this.$refs.checkoutRef.redirectToCheckout();
    },
  },
};
</script>